import safeFetch from '../extenstions/safeFetch';
import url from '../extenstions/url';

export default (setTeams) => safeFetch(`${url.teams}/all`)
    .then(setTeams);
